import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import xmlToJson from "../Components/xmlToJson";
moment.locale("es");

//Catálogo de motivos de cancelación del SAT, el mismo que ofrece el modal de cancelación.
//Un código de dos dígitos que no esté en el catálogo se imprime tal cual, pero el campo también
//guarda notas internas ("Cancelación detectada por consulta de estatus SAT", que escriben los
//checarEstatusFiscal*) y ésas no son un motivo fiscal: no se imprimen.
const textoMotivoCancelacion = (motivo) => {
    switch (motivo) {
        case "01":
            return "01 - Comprobante emitido con errores con relación.";
        case "02":
            return "02 - Comprobante emitido con errores sin relación.";
        case "03":
            return "03 - No se llevó a cabo la operación.";
        case "04":
            return "04 - Operación nominativa relacionada en una factura global.";
        default:
            return /^\d{2}$/.test(motivo) ? motivo : "";
    }
};

//El acuse sólo enseña el motivo y el folio de sustitución cuando los hay: una remisión o una
//cancelación detectada por consulta de estatus no traen ninguno de los dos.
const renglonesMotivoCancelacion = (cancelacion) => {
    const renglones = [];
    const motivo = textoMotivoCancelacion(cancelacion?.motivo);

    if (motivo) {
        renglones.push([
            { text: "Motivo de la cancelación:", style: "subheader" },
            { text: motivo, style: "textoChico" },
        ]);
    }

    if (cancelacion?.folioSustitucion) {
        renglones.push([
            { text: "Folio de sustitución:", style: "subheader" },
            { text: cancelacion.folioSustitucion, style: "textoChico" },
        ]);
    }

    return renglones;
};

//El acuse sólo lo devuelve el PAC al pedir la cancelación. Si la cancelación se hizo en el portal
//del SAT y el sistema apenas la detectó por consulta de estatus, no hay acuse que imprimir.
const leerAcuse = (acuseXml) => {
    if (!acuseXml || typeof acuseXml !== "string") {
        return { disponible: false };
    }

    try {
        const xmlAcuse = new xmlToJson().parseFromString(acuseXml);

        const folios = xmlAcuse?.children?.find((valueXml) => valueXml.name === "Folios");
        const signature = xmlAcuse?.children?.find((valueXml) => valueXml.name === "Signature");

        return {
            disponible: true,
            fecha: xmlAcuse?.attributes?.Fecha,
            uuid: folios?.children?.find((valueXml) => valueXml.name === "UUID")?.value,
            estatusUUID: folios?.children?.find((valueXml) => valueXml.name === "EstatusUUID")?.value,
            selloSAT: signature?.children?.find((valueXml) => valueXml.name === "SignatureValue")?.value,
        };
    } catch (error) {
        console.log("No se pudo parsear el acuse XML:", error.message);
        return { disponible: false };
    }
};

const LEYENDA_SIN_ACUSE = "Sin acuse del SAT — la cancelación se registró por consulta de estatus.";

const cancelarVentaPdf = (data) => {
    const empresa = data.empresa || {};
    const logoEmpresa = empresa.logo?.base64Completa || "";
    const logoBiwo = data.logoBiwo?.base64Completa || "";
    const dato = data.data || {};
    const cliente = data.cliente || {};

    const renglonesMotivo = renglonesMotivoCancelacion(dato?.cancelacion);

    if (data?.data?.remision === true && data?.data?.factura === false) {
        return {
            footer: { image: "logoBiwo", alignment: "center", width: 50 },
            content: [
                {
                    style: "tableExample",
                    table: {
                        widths: ["18%", "52%", "30%"],
                        layout: { defaultBorder: false },
                        body: [
                            [
                                {
                                    border: [false, false, false, false],
                                    image: "logo",
                                    fit: [80, 80],
                                },
                                {
                                    border: [false, false, false, false],
                                    table: {
                                        headerRows: 1,
                                        widths: ["100%"],
                                        body: [
                                            [{ text: empresa.nombreComercial ? empresa.nombreComercial : empresa.nombre || "Nombre Empresa", style: "tableHeader" }],
                                            [
                                                {
                                                    text: `R.F.C: ${empresa.rfc || "N/A"}`,
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                            [
                                                {
                                                    text: empresa.calle ? `${empresa.calle} ${empresa.numeroCalle || ""}` : "Dirección N/A",
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                            [
                                                {
                                                    text: empresa.colonia?.nombre
                                                        ? `${empresa.colonia.nombre} C.P. ${empresa.colonia.cp || "N/A"}`
                                                        : "Colonia N/A",
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                            [{ text: "ACUSE DE CANCELACIÓN DE REMISIÓN", style: "tableHeader" }],
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                                {
                                    border: [false, false, false, false],
                                    table: {
                                        headerRows: 1,
                                        widths: ["100%"],
                                        body: [
                                            [
                                                {
                                                    text: "Fecha:",
                                                    style: "subheader",
                                                    alignment: "center",
                                                },
                                            ],
                                            [
                                                {
                                                    text: dato?.cancelacion?.fechaCancelacion ? moment(dato.cancelacion.fechaCancelacion).format("DD [de] MMMM [de] YYYY") : " - ",
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                            ],
                        ],
                    },
                },
                {
                    style: "tableExample",
                    table: {
                        widths: ["50%", "50%"],
                        layout: { defaultBorder: false },
                        body: [
                            [
                                {
                                    table: {
                                        widths: ["50%", "50%"],
                                        layout: { defaultBorder: false },
                                        body: [
                                            [
                                                { text: "Folio:", style: "subheader" },
                                                { text: dato.remisionSerie + " - " + dato.remisionNumero || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "Clave del Receptor:", style: "subheader" },
                                                { text: cliente.clave || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "RFC del Receptor:", style: "subheader" },
                                                { text: cliente.rfc || "N/A", style: "textoChico" },
                                            ],
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                                {
                                    table: {
                                        widths: ["50%", "50%"],
                                        layout: { defaultBorder: false },
                                        body: [
                                            [
                                                { text: "Tipo de documento:", style: "subheader" },
                                                { text: "Remisión" || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "Nombre del Receptor:", style: "subheader" },
                                                { text: cliente.nombre + " " + cliente.apellidoPaterno + " " + cliente.apellidoMaterno || "N/A", style: "textoChico" },
                                            ],
                                            ...renglonesMotivo,
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                            ],
                        ],
                    },
                },
                {
                    style: "tableExample",
                    table: {
                        widths: ["60%", "20%", "20%"],
                        layout: { defaultBorder: true },
                        body: [
                            [
                                { text: "Folio", style: "tituloTabla" },
                                { text: "Estado", style: "tituloTabla" },
                                { text: "Importe", style: "tituloTabla" },
                            ],
                            [
                                { text: dato.remisionSerie + " - " + dato.remisionNumero || "N/A", style: "textoTabla", alignment: "center"},
                                { text: "Cancelado" || "N/A", style: "textoTabla", alignment: "center" },
                                { text: dineroDisabledMask(dato.totalPagar || 0), style: "textoTabla", alignment: "center" },
                            ],
                        ],
                    },
                },
            ],
            images: {
                logo: logoEmpresa,
                logoBiwo: logoBiwo,
            },
            styles: {
                header: { fontSize: 9, bold: true },
                subheader: { fontSize: 8, bold: true },
                tableExample: { margin: [0, 5, 0, 5] },
                tableHeader: { bold: true, fontSize: 12, alignment: "center" },
                textoChico: { fontSize: 8 },
                tituloTabla: {
                    fontSize: 8,
                    bold: true,
                    fillColor: "#cccccc",
                    alignment: "center",
                },
                textoTabla: { fontSize: 8 },
            },
            pageSize: "LETTER",
            pageMargins: [20, 20, 20, 20],
        };


    }else if(data?.data?.factura === true){

        const acuse = leerAcuse(dato?.cancelacion?.acuse);

        return {
            footer: { image: "logoBiwo", alignment: "center", width: 50 },
            content: [
                {
                    style: "tableExample",
                    table: {
                        widths: ["18%", "52%", "30%"],
                        layout: { defaultBorder: false },
                        body: [
                            [
                                {
                                    border: [false, false, false, false],
                                    image: "logo",
                                    fit: [80, 80],
                                },
                                {
                                    border: [false, false, false, false],
                                    table: {
                                        headerRows: 1,
                                        widths: ["100%"],
                                        body: [
                                            [{ text: empresa.nombreComercial ? empresa.nombreComercial : empresa.nombre || "Nombre Empresa", style: "tableHeader" }],
                                            [
                                                {
                                                    text: `R.F.C: ${empresa.rfc || "N/A"}`,
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                            [
                                                {
                                                    text: empresa.calle ? `${empresa.calle} ${empresa.numeroCalle || ""}` : "Dirección N/A",
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                            [
                                                {
                                                    text: empresa.colonia?.nombre
                                                        ? `${empresa.colonia.nombre} C.P. ${empresa.colonia.cp || "N/A"}`
                                                        : "Colonia N/A",
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                            [{ text: "ACUSE DE CANCELACIÓN DE CFDI", style: "tableHeader" }],
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                                {
                                    border: [false, false, false, false],
                                    table: {
                                        headerRows: 1,
                                        widths: ["100%"],
                                        body: [
                                            [
                                                {
                                                    text: "Fecha:",
                                                    style: "subheader",
                                                    alignment: "center",
                                                },
                                            ],
                                            [
                                                {
                                                    text: dato?.cancelacion?.fechaCancelacion ? moment(dato.cancelacion.fechaCancelacion).format("DD [de] MMMM [de] YYYY") : " - ",
                                                    style: "textoChico",
                                                    alignment: "center",
                                                },
                                            ],
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                            ],
                        ],
                    },
                },
                {
                    style: "tableExample",
                    table: {
                        widths: ["50%", "50%"],
                        layout: { defaultBorder: false },
                        body: [
                            [
                                {
                                    table: {
                                        widths: ["50%", "50%"],
                                        layout: { defaultBorder: false },
                                        body: [
                                            [
                                                { text: "Folio:", style: "subheader" },
                                                { text: dato.facturaSerie + " - " + dato.facturaNumero || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "Clave del Receptor:", style: "subheader" },
                                                { text: cliente.clave || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "RFC del Receptor:", style: "subheader" },
                                                { text: cliente.rfc || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "Fecha y hora de solicitud de la cancelación:", style: "subheader" },
                                                { text: acuse.fecha || "N/A", style: "textoChico" },
                                            ],
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                                {
                                    table: {
                                        widths: ["50%", "50%"],
                                        layout: { defaultBorder: false },
                                        body: [
                                            [
                                                { text: "Tipo de documento:", style: "subheader" },
                                                { text: "Factura - Ingreso" || "N/A", style: "textoChico" },
                                            ],
                                            [
                                                { text: "Nombre del Receptor:", style: "subheader" },
                                                { text: cliente.nombre + " " + cliente.apellidoPaterno + " " + cliente.apellidoMaterno || "N/A", style: "textoChico" },
                                            ],
                                            ...renglonesMotivo,
                                        ],
                                    },
                                    layout: "noBorders",
                                },
                            ],
                        ],
                    },
                },
                {
                    style: "tableExample",
                    table: {
                        widths: ["60%", "20%", "20%"],
                        layout: { defaultBorder: true },
                        body: [
                            [
                                { text: "Folio Fiscal (UUID)", style: "tituloTabla" },
                                { text: "Estado CFDI", style: "tituloTabla" },
                                { text: "Importe", style: "tituloTabla" },
                            ],
                            [
                                { text: acuse.uuid || dato?.dataFactura?.uuid || "N/A", style: "textoTabla", alignment: "center"},
                                { text: acuse.estatusUUID || "N/A", style: "textoTabla", alignment: "center" },
                                { text: dineroDisabledMask(dato.totalPagar || 0), style: "textoTabla", alignment: "center" },
                            ],
                        ],
                    },
                },
                [
                    { text: "Sello digital del SAT:"}
                ],
                [
                    { text: acuse.selloSAT || LEYENDA_SIN_ACUSE, style: "textoChico"}
                ],
            ],
            images: {
                logo: logoEmpresa,
                logoBiwo: logoBiwo,
            },
            styles: {
                header: { fontSize: 9, bold: true },
                subheader: { fontSize: 8, bold: true },
                tableExample: { margin: [0, 5, 0, 5] },
                tableHeader: { bold: true, fontSize: 12, alignment: "center" },
                textoChico: { fontSize: 8 },
                tituloTabla: {
                    fontSize: 8,
                    bold: true,
                    fillColor: "#cccccc",
                    alignment: "center",
                },
                textoTabla: { fontSize: 8 },
            },
            pageSize: "LETTER",
            pageMargins: [20, 20, 20, 20],
        }
    }

   
};

export default cancelarVentaPdf;
